import { render, staticRenderFns } from "./label-dialog.vue?vue&type=template&id=19a8091e&scoped=true"
import script from "./label-dialog.vue?vue&type=script&lang=js"
export * from "./label-dialog.vue?vue&type=script&lang=js"
import style0 from "./label-dialog.vue?vue&type=style&index=0&id=19a8091e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a8091e",
  null
  
)

export default component.exports